
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("619Qo", function(module, exports) {

var $iaYF8 = parcelRequire("iaYF8");

const $33c8d037de0a9b07$export$fc883aabd3b0aeb1 = (imageUrl)=>{
    if (!imageUrl) return false;
    return imageUrl?.includes((0, $iaYF8.UNSPLASH_URL));
};
module.exports["isUnsplashImage"] = $33c8d037de0a9b07$export$fc883aabd3b0aeb1;

});

parcelRegister("iaYF8", function(module, exports) {
const $e492801ff53d3706$export$fe42ffbf1f8cac0e = 'unsplash';
const $e492801ff53d3706$export$9d9758c15e32e47a = 'minimal';
const $e492801ff53d3706$export$4eb66a6321d4a29c = 'color';
module.exports["UNSPLASH_URL"] = $e492801ff53d3706$export$fe42ffbf1f8cac0e;
module.exports["DEFAULT_UNSPLASH_QUERY_WORD"] = $e492801ff53d3706$export$9d9758c15e32e47a;
module.exports["PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD"] = $e492801ff53d3706$export$4eb66a6321d4a29c;

});

parcelRegister("iMYjN", function(module, exports) {

var $619Qo = parcelRequire("619Qo");

const $90ce04f031631e3a$export$25f23b916a7baf7 = ({ imageSrc: imageSrc })=>{
    const isAbsoluteUrl = /^https?:\/\//.test(imageSrc || '');
    const isFileId = !isAbsoluteUrl && Boolean(imageSrc?.match(/([0-9a-fA-F-]{36})/));
    const showCustomUploadedImage = !!imageSrc && isFileId;
    const showUnsplashImage = !showCustomUploadedImage && (0, $619Qo.isUnsplashImage)(imageSrc);
    const showExternalSiteImage = !!imageSrc && !showCustomUploadedImage && !showUnsplashImage;
    return {
        showUnsplashImage: showUnsplashImage,
        showExternalSiteImage: showExternalSiteImage,
        showCustomUploadedImage: showCustomUploadedImage,
        hasImage: showUnsplashImage || showCustomUploadedImage || showExternalSiteImage
    };
};
const $90ce04f031631e3a$export$af23f40d1cee8ded = (url)=>{
    return new Promise((resolve)=>{
        // Creating an image element in memory to verify if the URL is a valid image
        const img = new Image();
        img.onload = ()=>resolve(true);
        img.onerror = ()=>resolve(false);
        img.src = url;
    });
};
const $90ce04f031631e3a$export$6535eb414fa2c8b6 = (url)=>{
    const trimmedUrl = url.trim();
    // If it already has a protocol, return as is
    if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) return trimmedUrl;
    // If it starts with //, add https:
    if (trimmedUrl.startsWith('//')) return `https:${trimmedUrl}`;
    // Otherwise, add https:// (default to secure)
    return `https://${trimmedUrl}`;
};
const $90ce04f031631e3a$export$bef94a5618bf18bf = (url)=>{
    const trimmedUrl = url.trim();
    // Handle empty strings
    if (!trimmedUrl) return false;
    // Check if it's already a valid URL with protocol
    if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) try {
        new URL(trimmedUrl);
        return true;
    } catch  {
        return false;
    }
    // For URLs without protocol, check if they look like valid domains
    // This prevents things like "invalid-url" from being normalized to "https://invalid-url"
    if (trimmedUrl.startsWith('//')) {
        // Protocol-relative URLs should have a valid domain after //
        const domainPart = trimmedUrl.substring(2);
        return domainPart.includes('.') && !domainPart.includes(' ');
    }
    // For URLs without protocol, they should look like valid domains
    // Must contain a dot (for domain) and no spaces
    if (trimmedUrl.includes('.') && !trimmedUrl.includes(' ')) // Basic domain validation - should have at least one dot and no spaces
    return true;
    return false;
};
module.exports["getImageTypeToShow"] = $90ce04f031631e3a$export$25f23b916a7baf7;
module.exports["isImageURL"] = $90ce04f031631e3a$export$af23f40d1cee8ded;
module.exports["normalizeUrl"] = $90ce04f031631e3a$export$6535eb414fa2c8b6;
module.exports["isValidUrl"] = $90ce04f031631e3a$export$bef94a5618bf18bf;

});

parcelRegister("dhLnb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cfM7x = parcelRequire("cfM7x");


var $4ZwXK = parcelRequire("4ZwXK");


var $iMYjN = parcelRequire("iMYjN");

const $2b58b7b153b52d1e$var$unboundedStyles = {
    image: "_0jFU0VN91d _39xV02N91d _00EA0eiObl"
};
const $2b58b7b153b52d1e$export$a8e6523ab063becd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { contentId: contentId, imageSrc: imageSrc, imageAlt: imageAlt, shouldShowExternalSiteImage: shouldShowExternalSiteImage, customMediaAuthProvider: customMediaAuthProvider, customCollectionId: customCollectionId } = t0;
    const { experienceSuccessComponent: experienceSuccessComponent } = (0, $cfM7x.useProductDependencies)();
    if (!imageSrc) return null;
    const { showUnsplashImage: showUnsplashImage, showCustomUploadedImage: showCustomUploadedImage, showExternalSiteImage: showExternalSiteImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const ExperienceSuccessComponent = experienceSuccessComponent || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    if (showUnsplashImage || shouldShowExternalSiteImage && showExternalSiteImage) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $hekY6.default)([
                $2b58b7b153b52d1e$var$unboundedStyles.image
            ]);
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] !== imageAlt || $[2] !== imageSrc || $[3] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                "data-testid": "img-element",
                alt: imageAlt,
                src: imageSrc,
                className: t1
            });
            $[1] = imageAlt;
            $[2] = imageSrc;
            $[3] = t1;
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] !== ExperienceSuccessComponent) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccessComponent, null);
            $[5] = ExperienceSuccessComponent;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    } else if (showCustomUploadedImage) {
        let t1;
        if ($[10] !== customCollectionId || $[11] !== customMediaAuthProvider) {
            t1 = {
                collection: customCollectionId,
                authProvider: customMediaAuthProvider
            };
            $[10] = customCollectionId;
            $[11] = customMediaAuthProvider;
            $[12] = t1;
        } else t1 = $[12];
        let t2;
        if ($[13] !== contentId || $[14] !== imageAlt || $[15] !== imageSrc || $[16] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ZwXK.CustomImageUploadRenderer), {
                contentId: contentId,
                imageSrc: imageSrc,
                imageAltText: imageAlt,
                shouldShowErrorMessage: true,
                mediaConfigOverride: t1
            });
            $[13] = contentId;
            $[14] = imageAlt;
            $[15] = imageSrc;
            $[16] = t1;
            $[17] = t2;
        } else t2 = $[17];
        return t2;
    }
    let t1;
    if ($[18] !== ExperienceSuccessComponent) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccessComponent, null);
        $[18] = ExperienceSuccessComponent;
        $[19] = t1;
    } else t1 = $[19];
    return t1;
} : ({ contentId: contentId, imageSrc: imageSrc, imageAlt: imageAlt, shouldShowExternalSiteImage: shouldShowExternalSiteImage, customMediaAuthProvider: customMediaAuthProvider, customCollectionId: customCollectionId })=>{
    const { experienceSuccessComponent: experienceSuccessComponent } = (0, $cfM7x.useProductDependencies)();
    if (!imageSrc) return null;
    const { showUnsplashImage: showUnsplashImage, showCustomUploadedImage: showCustomUploadedImage, showExternalSiteImage: showExternalSiteImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const ExperienceSuccessComponent = experienceSuccessComponent || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    if (showUnsplashImage || shouldShowExternalSiteImage && showExternalSiteImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        "data-testid": "img-element",
        alt: imageAlt,
        src: imageSrc,
        className: (0, $hekY6.default)([
            $2b58b7b153b52d1e$var$unboundedStyles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccessComponent, null));
    else if (showCustomUploadedImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ZwXK.CustomImageUploadRenderer), {
        contentId: contentId,
        imageSrc: imageSrc,
        imageAltText: imageAlt,
        shouldShowErrorMessage: true,
        mediaConfigOverride: {
            collection: customCollectionId,
            authProvider: customMediaAuthProvider
        }
    });
    // Fallback if nothing matches
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccessComponent, null);
};
module.exports["ImageRenderer"] = $2b58b7b153b52d1e$export$a8e6523ab063becd;

});

parcelRegister("4ZwXK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $lMGh1 = parcelRequire("lMGh1");


var $gIMcb = parcelRequire("gIMcb");


var $iQxQk = parcelRequire("iQxQk");


var $iMnC5 = parcelRequire("iMnC5");


var $b8pma = parcelRequire("b8pma");


var $cfM7x = parcelRequire("cfM7x");




const $b471e24caf412397$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    imageFailedMessage: {
        id: "company-hub.company-hub-common.link-cards.image-failed-to-load",
        defaultMessage: "Image failed to load"
    },
    warningIcon: {
        id: "company-hub.company-hub-common.link-cards.warning",
        defaultMessage: "Warning icon for image failed to load"
    }
});


const $71f5faa30087591b$var$IMAGE_CONFIGURATION = {
    allowAnimated: true,
    mode: 'fit',
    upscale: false
};
const $71f5faa30087591b$var$styles = {
    loading: "_39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0KLXrumhAQ",
    errorWrapper: "_3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _0jFU0VN91d _37wbyuDIqT _0hPCNLDIqT _0KLXrumhAQ",
    image: "_0jFU0VN91d _39xV02N91d _3v5uP0ZqHV _00EA0eiObl"
};
const $71f5faa30087591b$export$3f3413d4a48facf = ({ contentId: contentId, imageSrc: imageSrc = '', imageAltText: imageAltText, mediaConfigOverride: mediaConfigOverride, shouldShowErrorMessage: shouldShowErrorMessage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent, useMediaConfig: useMediaConfig } = (0, $cfM7x.useProductDependencies)();
    const { authProvider: authProvider, collection: collection, fileId: fileId } = useMediaConfig?.({
        contentId: contentId,
        imageSrc: imageSrc
    }) || {};
    const resolvedAuthProvider = mediaConfigOverride?.authProvider ?? authProvider;
    const resolvedCollectionName = mediaConfigOverride?.collection ?? collection;
    const identifier = (0, $cozmU.useMemo)(()=>({
            mediaItemType: 'file',
            id: fileId ?? '',
            collectionName: resolvedCollectionName ?? ''
        }), [
        fileId,
        resolvedCollectionName
    ]);
    if (!resolvedAuthProvider || !resolvedCollectionName || !imageSrc) return null;
    const errorState = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $71f5faa30087591b$var$styles.errorWrapper,
        testId: "custom-image-upload-error"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: intl.formatMessage((0, $b471e24caf412397$export$defe85febe8b728c).warningIcon),
        color: "var(--ds-icon-subtle, #505258)"
    }), shouldShowErrorMessage && /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $b471e24caf412397$export$defe85febe8b728c).imageFailedMessage));
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    return /*#__PURE__*/ $cozmU.createElement((0, $gIMcb.MediaClientProvider), {
        clientConfig: {
            authProvider: resolvedAuthProvider
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iQxQk.MediaImageWithErrorBoundary), {
        identifier: identifier,
        key: fileId,
        mediaClientConfig: {
            authProvider: resolvedAuthProvider
        },
        apiConfig: $71f5faa30087591b$var$IMAGE_CONFIGURATION
    }, ({ data: data, loading: loading, error: error })=>{
        if (loading) return /*#__PURE__*/ $cozmU.createElement((0, $b8pma.default), {
            name: "custom-uploaded-image-loading"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            testId: "custom-image-upload-loading",
            xcss: $71f5faa30087591b$var$styles.loading
        }));
        if (error || !data?.src) return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, errorState, /*#__PURE__*/ $cozmU.createElement(ExperienceError, {
            error: new Error('Image failed to load in CustomImageUploadRenderer')
        }));
        return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement("img", {
            src: data.src,
            alt: imageAltText,
            "data-testid": "custom-image-upload",
            className: (0, $hekY6.default)([
                $71f5faa30087591b$var$styles.image
            ])
        }), /*#__PURE__*/ $cozmU.createElement(ExperienceSuccess, null));
    }));
};
module.exports["CustomImageUploadRenderer"] = $71f5faa30087591b$export$3f3413d4a48facf;

});

parcelRegister("9n61H", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $w6R6I = parcelRequire("w6R6I");


var $l8Rhq = parcelRequire("l8Rhq");

var $3izAL = parcelRequire("3izAL");

var $2wCqQ = parcelRequire("2wCqQ");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");


var $jIDse = parcelRequire("jIDse");


var $cfM7x = parcelRequire("cfM7x");


var $hjUDQ = parcelRequire("hjUDQ");

/**
 * Validates and sanitizes a URL to prevent XSS attacks.
 *
 * @param url - The URL to validate and sanitize
 * @returns The sanitized URL or empty string if unsafe
 *
 */ const $6bc04d1b1e105bec$export$a5e3d4c760ae8d05 = (url)=>{
    if (!url || typeof url !== 'string') return '';
    url = url.trim();
    try {
        // In case of SSR, global window may not have been initialized
        const baseUrl = typeof window !== 'undefined' ? window.location.origin : undefined;
        const parsed = new URL(url, baseUrl);
        if (![
            'http:',
            'https:',
            'mailto:',
            'tel:'
        ].includes(parsed.protocol)) return '';
        return parsed.href;
    } catch  {
        return '';
    }
};



var $aOuIh = parcelRequire("aOuIh");




const $b6e07e79e8f27afe$var$_default_1 = (0, $kSwu1.defineMessages)({
    placeholderButtonLabel: {
        id: "company-hub.company-hub-common.spotlight.button-label.placeholder",
        defaultMessage: "View"
    }
});
var $b6e07e79e8f27afe$export$2e2bcd8739ae039 = $b6e07e79e8f27afe$var$_default_1;


const $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS = {
    small: 640,
    medium: 1400
};
const $0db27e7cdeb13f7e$var$styles = {
    baseWrapperStyles: "_0jFU0VN91d",
    smallStyles: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    mediumStyles: "_0Of8r2Va5s _1ZnuxbVa5s _1wydGWVa5s _2Zuz6QVa5s",
    largeStyles: "_0Of8r2GXk2 _1ZnuxbGXk2 _1wydGWGXk2 _2Zuz6QGXk2",
    largeTitle: "_2sNsIgxzFw",
    xlargeTitle: "_2sNsIgXwEm",
    xxlargeTitle: "_2sNsIgJ6H4",
    titleStyles: "_1kk5Tk7GSX",
    smallFrameStyles: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    mediumFrameStyles: "_0Of8r2NHnM _1wydGWNHnM _2Zuz6QVa5s _1ZnuxbVa5s",
    largeFrameStyles: "_0Of8r2Va5s _1ZnuxbVa5s _1wydGWVa5s _2Zuz6QVa5s"
};
const $0db27e7cdeb13f7e$export$c2176a81b9d23a65 = (width, layout)=>{
    if (layout === (0, $hjUDQ.CommonLayout).FRAME_ABOVE_IMAGE) {
        if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small) return 'smallFrameStyles';
        if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.medium) return 'mediumFrameStyles';
        return 'largeFrameStyles';
    }
    if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small) return 'smallStyles';
    if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.medium) return 'mediumStyles';
    return 'largeStyles';
};
const $0db27e7cdeb13f7e$var$baseButtonStyles = (0, $buxP3.xcss)({
    borderWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "5px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-radius-small, 5px)",
    transition: 'background 0.1s ease-out',
    borderStyle: 'solid',
    borderColor: 'color.border',
    paddingBlock: 'space.100',
    paddingInline: 'space.150',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    }
});
const $0db27e7cdeb13f7e$var$defaultButtonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.overlay.pressed'
    }
});
const $0db27e7cdeb13f7e$var$alternativeButtonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    ':hover': {
        backgroundColor: 'color.background.neutral.bold.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.bold.pressed'
    }
});
const $0db27e7cdeb13f7e$var$getTitleFontSize = (width)=>{
    if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small) return 'largeTitle';
    if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.medium) return 'xlargeTitle';
    return 'xxlargeTitle';
};
const $0db27e7cdeb13f7e$var$getDescriptionSize = (width)=>{
    if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small) return 'medium';
    return 'large';
};
const $0db27e7cdeb13f7e$var$getBaseLineCount = (isSplitLayout, width)=>{
    if (!isSplitLayout) return 8;
    if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small) return 3;
    return 6;
};
const $0db27e7cdeb13f7e$var$getDescriptionMaxLines = (isSplitLayout, width, isButtonShown)=>{
    const lines = $0db27e7cdeb13f7e$var$getBaseLineCount(isSplitLayout, width);
    return isButtonShown ? lines - 2 : lines;
};
const $0db27e7cdeb13f7e$export$e0b309a29dbe6cbc = ({ testId: testId, width: width = (0, $aOuIh.VERTICAL_MAX_WIDTH) + 1, layout: layout, textColor: savedTextColor, title: title, description: description, isButtonShown: isButtonShown, buttonText: buttonText, link: link, buttonStyle: buttonStyle, source: source, imageWidthPercentage: imageWidthPercentage = 0.5 })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const isSplitLayout = layout !== (0, $hjUDQ.CommonLayout).NO_IMAGE_BACKGROUND && layout !== (0, $hjUDQ.CommonLayout).FRAME_ABOVE_IMAGE;
    const isDefaultButtonStyle = buttonStyle === (0, $hjUDQ.ButtonStyle).DEFAULT;
    const { getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    const textColor = getDarkModeCompatibleTextColor(savedTextColor);
    const handleButtonClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'spotlightButton',
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const bodyTextMaxLines = (0, $cozmU.useMemo)(()=>$0db27e7cdeb13f7e$var$getDescriptionMaxLines(isSplitLayout, width, isButtonShown), [
        isSplitLayout,
        width,
        isButtonShown
    ]);
    const titleMaxLines = ()=>{
        if (!description) return 5;
        if (imageWidthPercentage > 0.5 && width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small) return 2;
        return 3;
    };
    const safeUrl = (0, $6bc04d1b1e105bec$export$a5e3d4c760ae8d05)(link);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        grow: "fill",
        space: width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small ? 'space.150' : 'space.200',
        alignInline: "start",
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)($0db27e7cdeb13f7e$var$styles.baseWrapperStyles, $0db27e7cdeb13f7e$var$styles[$0db27e7cdeb13f7e$export$c2176a81b9d23a65(width, layout)]),
        testId: testId
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        align: "start",
        color: "inherit",
        maxLines: titleMaxLines(),
        testId: "spotlight-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ), {
        style: {
            color: textColor
        },
        xcss: (0, $w6R6I.cx)($0db27e7cdeb13f7e$var$styles[$0db27e7cdeb13f7e$var$getTitleFontSize(width)], $0db27e7cdeb13f7e$var$styles.titleStyles)
    }, title)), description && bodyTextMaxLines > 0 && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        testId: "spotlight-description",
        align: "start",
        color: "inherit",
        size: $0db27e7cdeb13f7e$var$getDescriptionSize(width),
        maxLines: bodyTextMaxLines
    }, description)), isButtonShown && safeUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.Anchor), {
        onClick: handleButtonClick,
        href: safeUrl,
        xcss: [
            $0db27e7cdeb13f7e$var$baseButtonStyles,
            isDefaultButtonStyle ? $0db27e7cdeb13f7e$var$defaultButtonStyles : $0db27e7cdeb13f7e$var$alternativeButtonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        weight: "medium",
        color: isDefaultButtonStyle ? 'color.text' : 'color.text.inverse',
        maxLines: 1
    }, buttonText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b6e07e79e8f27afe$export$2e2bcd8739ae039).placeholderButtonLabel))));
};
module.exports["SpotlightContent"] = $0db27e7cdeb13f7e$export$e0b309a29dbe6cbc;

});

parcelRegister("aOuIh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $jIDse = parcelRequire("jIDse");


var $eafQX = parcelRequire("eafQX");


var $cfM7x = parcelRequire("cfM7x");


var $51SAu = parcelRequire("51SAu");


var $hjUDQ = parcelRequire("hjUDQ");


var $4WDWC = parcelRequire("4WDWC");

const { NO_IMAGE_BACKGROUND: $f0fd9cc53505a377$var$NO_IMAGE_BACKGROUND, SPLIT_IMAGE_LEFT: $f0fd9cc53505a377$var$SPLIT_IMAGE_LEFT, SPLIT_IMAGE_RIGHT: $f0fd9cc53505a377$var$SPLIT_IMAGE_RIGHT, FRAME_ABOVE_IMAGE: $f0fd9cc53505a377$var$FRAME_ABOVE_IMAGE } = (0, $hjUDQ.CommonLayout); /**
                   * The maximum width in pixels at which the layout is oriented vertically, at larger widths it is horizontal.
                   */ 
const $f0fd9cc53505a377$export$a24d4999f7186564 = 640;
const $f0fd9cc53505a377$var$FRAME_MAX_WIDTH = 486;
const $f0fd9cc53505a377$var$CENTERED_FRAME_WIDTH = 364;
const $f0fd9cc53505a377$var$WIDE_FRAME_WIDTH = 393;
const $f0fd9cc53505a377$var$FULL_WIDTH_FRAME_WIDTH = 512;
const $f0fd9cc53505a377$var$percentageStyles = {
    flex: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0jFU0VN91d",
    imageSide: "_2O5VijdnbC _3YEZNOdnbC",
    childrenSide: "_2O5Vij7dHp",
    borderStyle: "_30huDKOeNX"
};
const $f0fd9cc53505a377$var$gridStyles = {
    grid: "_3iDTPbgBM8 _0jFU0VN91d _0ca6V7clzJ",
    frameChildren: "_0bjKvD8fU6 _2j3gqAtfzM _3B2K2QE1JG _2YLqiKVa5s",
    fullImage: "_4bt5LAnQyn _2WAcuGnQyn _30huDKOeNX _2j3gqAg8pm _3B2K2Qg8pm _0jFU0VN91d",
    roundedBorderRadius: "_0bjKvDyzSk",
    smallFrameStyling: "_2YLqiK5zaO _1EqgXlq322",
    centeredFrameStyling: "_2YLqiKVa5s _39xV02UTds _1EqgXlq322",
    wideFrameStyling: "_2YLqiKVa5s _39xV02ky9M _1EqgXlq322",
    fullWidthFrameStyling: "_2YLqiKGXk2 _39xV026PwL"
};
function $f0fd9cc53505a377$var$spotlightToCssHeight(height) {
    switch(height){
        case (0, $hjUDQ.Height).SMALL:
            return 248;
        case (0, $hjUDQ.Height).MEDIUM:
            return 400;
        case (0, $hjUDQ.Height).LARGE:
        default:
            return 620;
    }
}
var $f0fd9cc53505a377$export$262fb604e10a6da8 = /*#__PURE__*/ function(SpotlightWidth) {
    SpotlightWidth[SpotlightWidth["SMALL"] = 356] = "SMALL";
    SpotlightWidth[SpotlightWidth["CENTERED"] = 800] = "CENTERED";
    SpotlightWidth[SpotlightWidth["WIDE"] = 1050] = "WIDE";
    SpotlightWidth[SpotlightWidth["FULL_WIDTH"] = 1840] = "FULL_WIDTH";
    return SpotlightWidth;
}({});
function $f0fd9cc53505a377$export$e2db3adb05a4002(width) {
    if (width <= 356) return 'smallFrameStyling';
    if (width <= 800) return 'centeredFrameStyling';
    if (width <= 1050) return 'wideFrameStyling';
    return 'fullWidthFrameStyling';
}
function $f0fd9cc53505a377$export$40cf3f2715085991({ backgroundColor: savedBackgroundColor, children: children, cornerRadiusOverride: cornerRadiusOverride, height: height, image: image, layout: layout, testId: testId, width: width = $f0fd9cc53505a377$export$a24d4999f7186564 + 1, imageWidthPercentage: imageWidthPercentage = 0.5, hasRoundedCorners: hasRoundedCorners }) {
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, hideExtensionBorders: hideExtensionBorders } = (0, $cfM7x.useProductDependencies)();
    const { getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    const backgroundColor = getDarkModeCompatibleBackgroundColor(savedBackgroundColor);
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)(); // Per-element corner radius is Premium. The value lives in the ADF, so a
    // downgrade cannot clear it — ignoring the override makes the extension
    // inherit the hub-wide radius, which the backend resets to the 8px default.
    const isCornerRadiusLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    if (!image) layout = $f0fd9cc53505a377$var$NO_IMAGE_BACKGROUND;
    const showVerticalLayout = width < $f0fd9cc53505a377$export$a24d4999f7186564; // In the small-height layout, if there's an image, its width is fixed:
    let imageWidth;
    if (height === (0, $hjUDQ.Height).SMALL && (layout === $f0fd9cc53505a377$var$SPLIT_IMAGE_LEFT || layout === $f0fd9cc53505a377$var$SPLIT_IMAGE_RIGHT)) {
        if (width >= 1024) imageWidth = 514;
        else if (width >= 768) imageWidth = 186;
        else if (width > $f0fd9cc53505a377$export$a24d4999f7186564) imageWidth = 140;
        else imageWidth = 84;
    }
    const getFlexDirection = ()=>{
        if (showVerticalLayout) return layout === $f0fd9cc53505a377$var$SPLIT_IMAGE_LEFT ? 'column' : 'column-reverse';
        return layout === $f0fd9cc53505a377$var$SPLIT_IMAGE_LEFT ? 'row' : 'row-reverse';
    };
    return layout === $f0fd9cc53505a377$var$FRAME_ABOVE_IMAGE ? /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        style: {
            height: `${$f0fd9cc53505a377$var$spotlightToCssHeight(height)}px`
        },
        className: (0, $hekY6.default)([
            $f0fd9cc53505a377$var$gridStyles.grid
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId ? `${testId}-image` : undefined,
        style: isCornerRadiusEnabled ? {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            borderRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
            ...!isCornerRadiusLocked && typeof cornerRadiusOverride === 'number' ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(cornerRadiusOverride)}px`
            } : {}
        } : undefined,
        className: (0, $hekY6.default)([
            $f0fd9cc53505a377$var$gridStyles.fullImage,
            hasRoundedCorners && $f0fd9cc53505a377$var$gridStyles.roundedBorderRadius
        ])
    }, image), /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...isCornerRadiusEnabled ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                borderRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
                ...!isCornerRadiusLocked && typeof cornerRadiusOverride === 'number' ? {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(cornerRadiusOverride)}px`
                } : {}
            } : {}
        },
        className: (0, $hekY6.default)([
            $f0fd9cc53505a377$var$gridStyles.frameChildren,
            $f0fd9cc53505a377$var$gridStyles[$f0fd9cc53505a377$export$e2db3adb05a4002(width)]
        ])
    }, children)) : /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        style: {
            backgroundColor: backgroundColor,
            height: `${$f0fd9cc53505a377$var$spotlightToCssHeight(height)}px`,
            flexDirection: getFlexDirection(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...isCornerRadiusEnabled ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                borderRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
                ...!isCornerRadiusLocked && typeof cornerRadiusOverride === 'number' ? {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(cornerRadiusOverride)}px`
                } : {}
            } : {
                borderRadius: hasRoundedCorners ? "var(--ds-radius-xlarge, 12px)" : 0
            }
        },
        className: (0, $hekY6.default)([
            $f0fd9cc53505a377$var$percentageStyles.flex,
            !hideExtensionBorders && $f0fd9cc53505a377$var$percentageStyles.borderStyle
        ])
    }, layout !== $f0fd9cc53505a377$var$NO_IMAGE_BACKGROUND && /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            flexBasis: imageWidth || `${imageWidthPercentage * 100}%`,
            height: showVerticalLayout ? `${$f0fd9cc53505a377$var$spotlightToCssHeight(height) * imageWidthPercentage}px` : '100%'
        },
        className: (0, $hekY6.default)([
            $f0fd9cc53505a377$var$percentageStyles.imageSide
        ])
    }, image), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $f0fd9cc53505a377$var$percentageStyles.childrenSide
        ])
    }, children));
}
module.exports["VERTICAL_MAX_WIDTH"] = $f0fd9cc53505a377$export$a24d4999f7186564;
module.exports["SpotlightLayout"] = $f0fd9cc53505a377$export$40cf3f2715085991;

});


//# sourceMappingURL=cards-extension.0d1f05e2.js.map
